__webpack_require__.p = "/worldscope-ui/";